import { prop } from '@ipfabric/utils/fp/prop';
import { getWindowGreatestZIndex } from 'components/DeviceView/helpers/getWindowGreatestZIndex';
import { type FC, memo } from 'react';
import { useDeviceViewContextSelectors } from '../model/DeviceViewModel';
import { DeviceViewWindow } from './DeviceViewWindow';

const BareDeviceViewWindows: FC = () => {
  const ctxProps = useDeviceViewContextSelectors({
    deviceViewWindows: prop('deviceViewWindows'),
  });

  const greatestZIndex = getWindowGreatestZIndex(ctxProps.deviceViewWindows);

  return (
    <div className='deviceView-windows__container z-elevated absolute order-first flex flex-col'>
      {ctxProps.deviceViewWindows.map((deviceViewWindow) => (
        <DeviceViewWindow
          active={greatestZIndex === deviceViewWindow.zIndex}
          deviceViewEntityId={deviceViewWindow.id}
          key={deviceViewWindow.id}
          {...deviceViewWindow}
        />
      ))}
    </div>
  );
};

export const DeviceViewWindows = memo(BareDeviceViewWindows);
